module.exports = __webpack_public_path__ + "img/and_pump(old).e2ded63f.png";